import { Injectable } from '@angular/core';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';
import { DefaultService, APIErrorReport} from "@psnb/psnb-api";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelApierrorReportService {

  constructor(private powerSupplyService: DefaultService) { }

  public getPowerSuppliesByAPIErrorReports(nodeId, regionName) {
    return this.powerSupplyService.getPowerSuppliesByAPIErrorReports(nodeId, regionName);
  }

  public exportApiErrorReportAsExcelFile(json: APIErrorReport[], excelFileName: string, fileType: string) {
    let min = 0;
    let max = 40000;
    let numberOfSheets = 0;
    if (json.length >= 40000) {
      if (json.length % 40000 === 0) numberOfSheets = json.length / 40000;
      else numberOfSheets = json.length / 40000 + 1;
    } else {
      numberOfSheets = 1;
      max = json.length;
    }
    const workbook = new Excel.Workbook;
    for (let i = 1; i <= numberOfSheets; i++) {
      workbook.addWorksheet('APUError' + i);
      const sheet = workbook.getWorksheet(i);
      sheet.columns = this.getHeaders(fileType, json.slice(min, max));
      sheet.addRows(json.slice(min, max));
      if (fileType === 'APIERRORBYNODE') {
        sheet.eachRow(function (row, rowNumber) {
          row.eachCell({ includeEmpty: true }, function (cell) {
            if (rowNumber === 1) {
              sheet.getCell(cell.address.toString()).fill = {
                type: 'gradient', gradient: 'angle', degree: 0, stops: [
                  { position: 0, color: { argb: 'd9f1fa' } },
                  { position: 0.5, color: { argb: 'd9f1fa' } },
                  { position: 1, color: { argb: 'd9f1fa' } }
                ]
              };
              sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
              sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
              sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
            } else {
              sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
              sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
              sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8 };
            }
          });
        });
      }
      if (max + 40000 <= json.length) {
        min = max;
        max = max + 40000;
      } else {
        min = max;
        max = max + (json.length - max);
      }
    }
    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
    });
    return false;
  }

  getHeaders(fileType: string, json: APIErrorReport[]) {
    if (fileType === 'APIERRORBYNODE') {
      let wchRegionName = 11;
      let wchHeadendName = 12;
      let wchCommunityName = 14;
      let wchPowerSupplyName = 15;
      let wchMacAddress = 15;
      let wchName = 8;
      let wchPowerSupplyId = 14;
      let wchApiResults = 35;
      json.forEach(element => {
        if (element.regionName !== null && wchRegionName <= element.regionName.length) {
          wchRegionName = element.regionName.length;
        }
        if (element.headEndName !== null && wchHeadendName <= element.headEndName.length) {
          wchHeadendName = element.headEndName.length;
        }
        if (element.communityName !== null && wchCommunityName <= element.communityName.length) {
          wchCommunityName = element.communityName.length;
        }
        if (element.powerSupplyName !== null && wchPowerSupplyName <= element.regionName.length) {
          wchPowerSupplyName = element.powerSupplyName.length;
        }
      });
      return [
        { header: 'RegionName', key: 'regionName', width: wchRegionName, style: { 'font': { name: 'Calibri', family: 2, size: 8 } }, 'alignment': { wrapText: true, vertical: 'middle', horizontal: 'center' } },
        { header: 'HeadendName', key: 'headEndName', width: wchHeadendName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'CommunityName', key: 'communityName', width: wchCommunityName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'MACAddress', key: 'macAddress', width: wchMacAddress, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Name', key: 'name', width: wchName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'APIResults', key: 'apiResults', width: wchApiResults, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
      ]
    }
  }
}
